module.exports = __webpack_public_path__ + "static/media/temp-01-yellow.1cd4deb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/temp-01-yellow.png
// module id = 7692
// module chunks = 0